var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.computedDivClass},[_c('v-radio-group',{attrs:{"row":_vm.horizontal}},_vm._l((_vm.buttons),function(n){return _c('v-radio',{key:n,attrs:{"color":_vm.color,"label":`${n}`,"value":n}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }